// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".hrm-card[data-v-1d474c49]{width:332px}@media screen and (max-width:767px){.hrm-card[data-v-1d474c49]{width:312px}}@media screen and (max-width:380px){.hrm-card[data-v-1d474c49]{max-width:375px;width:100%}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
